import $ from "jquery";

$('.product-images__thumbnails-item').on('click', function(e) {
    e.preventDefault();
    var thumb_id = $(this).attr('href');

    $('.product-images__thumbnails-item').removeClass('current');
    $('.product-images__image-large').removeClass('current');

    $(this).addClass('current');
    $(thumb_id).addClass('current');
});

(function ($) {
    let galleryOptions = {
        rel:'gal',
        width: '90%',
        height: '90%',
        maxWidth: '550px',
        maxHeight: '650px',
        current: "{current}/{total}"
    }

    function productGallery() {
        let $gallery = $('.product-images__image-large--image').colorbox(galleryOptions);
        return $gallery;
    }

    function resizeGallery($gallery) {
        $gallery.colorbox.resize({
            width: window.innerWidth > parseInt(galleryOptions.maxWidth) ? galleryOptions.maxWidth : galleryOptions.width,
            height: window.innerHeight > parseInt(galleryOptions.maxHeight) ? galleryOptions.maxHeight : galleryOptions.height
        });
    }

    $(window).on('load', function() {
        productGallery();
    });
    
    $(window).bind('resize', function() {
        resizeGallery(productGallery());
    });

})(jQuery);
